<label  *ngIf="alwaysShow || (control && control.invalid)" class="label info-content" style="white-space: pre-wrap;">
    <i class="fa fa-info-circle"></i> 
    <ng-content></ng-content>
</label> 